import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Connects to data-controller="infinite-scroll"
export default class extends Controller {
  static targets = ["sentinel"]
  static values = {
    url: String,
    loading: { type: Boolean, default: false }
  }

  connect() {
    this.setupObserver()

    // Turbo Stream으로 새 sentinel이 추가될 때 다시 observe
    document.addEventListener("turbo:before-stream-render", this.handleStreamRender.bind(this))
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    document.removeEventListener("turbo:before-stream-render", this.handleStreamRender.bind(this))
  }

  setupObserver() {
    if (this.observer) {
      this.observer.disconnect()
    }

    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        root: null,
        rootMargin: "200px",
        threshold: 0
      }
    )

    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget)
    }
  }

  handleStreamRender(event) {
    // Turbo Stream 렌더 후 새 sentinel 감지
    setTimeout(() => {
      if (this.hasSentinelTarget) {
        // sentinel의 data-url에서 다음 페이지 URL 읽기
        const nextUrl = this.sentinelTarget.dataset.nextUrl
        if (nextUrl) {
          this.urlValue = nextUrl
        }
        this.observer.observe(this.sentinelTarget)
      }
    }, 100)
  }

  sentinelTargetConnected(target) {
    // 새 sentinel이 연결되면 URL 업데이트하고 observe
    const nextUrl = target.dataset.nextUrl
    if (nextUrl) {
      this.urlValue = nextUrl
    }
    if (this.observer) {
      this.observer.observe(target)
    }
  }

  handleIntersection(entries) {
    const entry = entries[0]
    if (entry.isIntersecting && !this.loadingValue) {
      // sentinel의 data-next-url 또는 controller의 urlValue 사용
      const url = this.sentinelTarget?.dataset?.nextUrl || this.urlValue
      if (url) {
        this.loadMore(url)
      }
    }
  }

  async loadMore(url) {
    if (this.loadingValue || !url) return

    this.loadingValue = true
    this.showLoading()

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Network response was not ok")

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error("Infinite scroll error:", error)
      // 에러 시 sentinel 복원
      if (this.hasSentinelTarget) {
        this.sentinelTarget.innerHTML = `
          <td colspan="100%" class="py-4 text-center text-red-500">
            로딩 실패. 스크롤하여 다시 시도하세요.
          </td>
        `
      }
    } finally {
      this.loadingValue = false
    }
  }

  showLoading() {
    if (this.hasSentinelTarget) {
      this.sentinelTarget.innerHTML = `
        <td colspan="100%" class="py-4 text-center">
          <span class="loading loading-spinner loading-sm"></span>
          <span class="ml-2 text-gray-500">로딩 중...</span>
        </td>
      `
    }
  }
}
